import React from 'react';
import Toggle from '../../../common/Toggle';
import '../workspace.scss';
import List from './List';
import SimpleTooltip from '../../../common/tooltip/SimpleTooltip';
import LockedDiv from '../../../common/locked-div/LockedDiv';

class Index extends React.Component {
  renderAction = toggle => {
    return (
      <SimpleTooltip
        message={'layout.tooltipSideBar.OPEN_WORKSPACE'}
        position={'right'}
        isI18n={true}
        appendClassName={'d-block'}
        appendStyle={{ zIndex: 99999 }}
      >
        <a href="#" aria-haspopup="true" aria-expanded="false" onClick={toggle}>
          <i id="workspace-tutorial" className="icon-slide" />
        </a>
      </SimpleTooltip>
    );
  };

  renderPopup = (showHide, isShow) => {
    return (
      isShow && (
        <div
          className={`dropdown-menu sidebar-drop show`}
          aria-labelledby="dropdownMenuButton"
          style={{
            position: 'absolute',
            willChange: 'transform',
            top: '0px',
            left: '0px',
            transform: 'translate3d(5px, 40px, 0px)',
          }}
        >
          <List showHide={showHide} isShow={isShow} />
        </div>
      )
    );
  };

  render() {
    return (
      <li className="workspace-wrap">
        <div className="side-dropdown right setting-header">
          <div className="dropdown">
            <Toggle
              renderAction={this.renderAction}
              renderPopup={this.renderPopup}
            />
          </div>
        </div>
      </li>
    );
  }
}

export default Index;
